import { VpnKeyRounded } from '@material-ui/icons';
import Async from '../../components/Async';

const AuthGuard = Async(() => import('../auth.guard'));
const CourtAuthenticators = Async(() =>
    import('../../pages/operations/court-authenticators/court.authenticators')
);

// Só quem tem a role court_authenticator (Bianca e Lucila); admin não herda. A API confere de novo a cada consulta.
const routes = {
    courtAuthenticators: {
        id: 'courtAuthenticators',
        name: 'Códigos de acesso dos tribunais',
        path: '/court-authenticators',
        component: CourtAuthenticators,
        guard: AuthGuard,
        icon: <VpnKeyRounded />,
        roles: ['court_authenticator']
    }
};

const pages = Object.values(routes);

const courtAuthenticatorRoute = {
    routes,
    pages
};

export default courtAuthenticatorRoute;
